import React from 'react';

interface ProcessingStatusProps {
  processedImages: number;
  totalImages: number;
  progressPercentage: number;
  isComplete: boolean;
  completedAt: string | null;
}

const ProcessingStatus: React.FC<ProcessingStatusProps> = ({
  processedImages,
  totalImages,
  progressPercentage,
  isComplete,
  completedAt,
}) => {
  const isInProgress = !isComplete || !completedAt;
  const barColor = isInProgress ? 'bg-blue-500' : 'bg-green-500';
  const textColor = isInProgress ? 'text-blue-700' : 'text-green-700';
  const bgColor = isInProgress ? 'bg-blue-50' : 'bg-green-50';
  const borderColor = isInProgress ? 'border-blue-200' : 'border-green-200';

  return (
    <div className="px-4">
      <div className={`mb-6 p-4 rounded-lg border ${bgColor} ${borderColor}`}>
        <div className="flex items-center justify-between mb-2">
          <h3 className={`text-sm font-semibold ${textColor}`}>
            {isInProgress ? 'Procesando imágenes...' : 'Proceso completado'}
          </h3>
          <span className={`text-sm font-medium ${textColor}`}>
            {processedImages} / {totalImages} imágenes
          </span>
        </div>

        <div className="w-full bg-gray-200 rounded-full h-3 mb-2 overflow-hidden">
          <div
            className={`h-full ${barColor} transition-all duration-300 ease-in-out`}
            style={{ width: `${progressPercentage}%` }}
          />
        </div>

        <div className="flex items-center justify-between text-xs">
          <span className="text-gray-600">
            {progressPercentage.toFixed(1)}% completado
          </span>
          {isInProgress && (
            <span className="text-gray-500 animate-pulse">
              Actualizando...
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProcessingStatus;
